define('../app/fukit/view/common/simple.pagination.view',['require','exports','module','uikit/uikit','../../helpers/extend.util','../../helpers/formatter','../../behavior/bind.and.format.option.values.behavior','templates','../../behavior/invoke.service.method.on.event.behavior'],function(require, exports, module) {
  //prettier-ignore
  var UIKit                              = require('uikit/uikit'),
      ExtendUtil                         = require('../../helpers/extend.util'),
      Formatter                          = require('../../helpers/formatter'),
      BindAndFormatOptionValuesBehavior  = require('../../behavior/bind.and.format.option.values.behavior'),
      Templates                          = require('templates'),
      InvokeServiceMethodOnEventBehavior = require('../../behavior/invoke.service.method.on.event.behavior');

  var SimplePaginationView = UIKit.ItemView.extend({
    template: Templates.App['simple.pagination'],

    internalViewOptions: {
      previousButtonView: ExtendUtil.extendOptionValueWithDefaults('previousButton', {
        type: UIKit.Button,
        text: 'Prev',
        model: '@model',
        behaviors: {
          BindAndFormatOptionValuesBehavior: {
            optionValues: {
              disabled: {
                formatter: Formatter.serviceMethod('paginationService', 'isFirstPage'),
              },
            },
            behaviorClass: BindAndFormatOptionValuesBehavior,
          },
          InvokeServiceMethodOnEventBehavior: {
            serviceName: 'paginationService',
            method: 'previousPage',
            methodArguments: ['@model', '@state', '@this.statePageAttribute'],
            behaviorClass: InvokeServiceMethodOnEventBehavior,
          },
        },
      }),
      paginationCountView: ExtendUtil.extendOptionValueWithDefaults('paginationCount', {
        type: UIKit.Text,
        model: '@model',
        behaviors: {
          BindAndFormatOptionValuesBehavior: {
            optionValues: {
              text: {
                formatter: Formatter.serviceMethod('paginationService', 'pageCountTitle'),
              },
            },
            behaviorClass: BindAndFormatOptionValuesBehavior,
          },
        },
      }),
      nextButtonView: ExtendUtil.extendOptionValueWithDefaults('nextButton', {
        type: UIKit.Button,
        text: 'Next',
        model: '@model',
        behaviors: {
          BindAndFormatOptionValuesBehavior: {
            optionValues: {
              disabled: {
                formatter: Formatter.serviceMethod('paginationService', 'isLastPage'),
              },
            },
            behaviorClass: BindAndFormatOptionValuesBehavior,
          },
          InvokeServiceMethodOnEventBehavior: {
            serviceName: 'paginationService',
            method: 'nextPage',
            methodArguments: ['@model', '@state', '@this.statePageAttribute'],
            behaviorClass: InvokeServiceMethodOnEventBehavior,
          },
        },
      }),
    },
  });

  module.exports = SimplePaginationView;
});

